import classNames from "classnames";
import React, {useEffect, useState} from 'react'
import {Link, NavLink} from "react-router-dom";
import imagesPath from "../config/imagesPath";

const Headers = () => {
    const [isShrunk, setShrunk] = useState(false);
    const [prevScrollpos, setprevScrollpos] = useState(window.pageYOffset);
    const [visible, setVisible] = useState(true);
    const [showmenu, setShowMenu] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            if (
                !isShrunk &&
                (document.body.scrollTop > 20 ||
                    document.documentElement.scrollTop > 20)
            ) {
                setShrunk(true);
            } else {
                setShrunk(false);
            }
            return isShrunk;
        };

        window.addEventListener("scroll", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("scroll", handleScroll());
        }
    }, []);
    const handleScroll = () => {
        const currentScrollPos = window.pageYOffset;
        const visible = prevScrollpos > currentScrollPos;
        setprevScrollpos(currentScrollPos)
        setVisible(visible)
    };
    const showmenuClk = () => {
        setShowMenu(!showmenu)
    }

    const menuItems = [
        {
            title: 'Electric Three Wheeler Loan',
            path: "/product/#5e8c3bd323c56a069a0a1836",
            id: '5e8c3bd323c56a069a0a1836'
        },
        {
            title: 'Electric Two Wheeler Loan',
            path: "/product/#5e8c408123c56a069a0a1837",
            id: '5e8c408123c56a069a0a1837'
        },
        {
            title: 'Rev Loan',
            path: "/product/#5e8c43fa23c56a069a0a183b",
            id: '5e8c43fa23c56a069a0a183b'
        },
        {
            title: 'EV Ancillary Loan',
            path: "/product/#5ee859f9441ec6f8d2e6f173",
            id: '5ee859f9441ec6f8d2e6f173'
        },
        {
            title: 'Electric Two Wheeler Lease',
            path: "/product/#641403c8f2730717d4cd9189",
            id: '641403c8f2730717d4cd9189'
        }
    ]
    useEffect((id) => {
        window.addEventListener("scroll", goToViolation = (id));
        return () => {
            window.removeEventListener("scroll", goToViolation = (id));
        }
    }, [])
    let goToViolation = (id) => {
        const violation = document.getElementById(id);
        window.scrollTo({
            top: violation ? violation.offsetTop : '',
            behavior: "smooth"
        });
    };
    return (
        <div className="header-width">
            <section id="topbar" className="d-flex align-items-center">
                <div className="container d-flex justify-content-end justify-content-md-between">
                    <div className="contact-info d-flex align-items-center"></div>
                    <div className="social-links  d-md-flex align-items-center">
                        <a href="https://www.linkedin.com/company/revfinserv/" target="_blank" className="linkedin"><i
                            className="bi bi-linkedin"></i></a>
                        <a href="https://www.youtube.com/channel/UCQapP0XsbMsCRe5LM_MRYzw?view_as=subscriber"
                            target="_blank" className="youtube"><i className="bi bi-youtube"></i></a>
                        <a href="https://www.facebook.com/revfinindia/" target="_blank" className="facebook"><i
                            className="bi bi-facebook"></i></a>
                        <a href="https://www.instagram.com/revfinindia/" target="_blank" className="instagram"><i
                            className="bi bi-instagram"></i></a>
                        <a href="https://twitter.com/revfinindia" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
                            <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                        </svg></a>
                    </div>
                </div>
            </section>
            <div className="d-none d-md-block d-lg-block">
                <header id="header" className={classNames(
                    "non-shrink d-flex align-items-center",
                    {"shrink d-flex align-items-center": isShrunk}
                )}>
                    <div className="container " style={{
                        display: 'flex',
                        justifyContent: ' space-between',
                        alignItems: 'center',
                    }}>
                        <div className="logo">
                            <NavLink to="/"><img src={require("../images/logo.png")} alt="logo"/></NavLink>
                        </div>
                        <div className="humbargermenu" onClick={showmenuClk}>
                            <img src={require('../images/humbarger_menu.png')} alt="" className="hum"/>
                            <img src={require('../images/humbarger_menu_white.png')} alt="" className="humwhite"/>
                        </div>
                        <div className={`menuOverlay ${showmenu ? 'showmenuoverlay' : ''}`}
                             onClick={showmenuClk}>
                        </div>
                        <nav id="navbar" className={`${showmenu ? 'showmenu' : 'navbar'}`}>
                            <div className="closemenu" onClick={showmenuClk}><i className="fas fa-times"/></div>
                            <ul>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive"
                                             to="/">Home</NavLink></li>
                                <li className="dropdown"><NavLink exact activeclass="navactive"
                                                                  to="/product"><span>Products</span> <i
                                    className="bi bi-chevron-down"></i></NavLink>
                                    <ul>
                                        {
                                            menuItems.map((ele, index) => {
                                                return (
                                                    <li key={index}><Link to={ele.path} onClick={() => {
                                                        goToViolation(ele.id)
                                                    }}>{ele.title}</Link></li>
                                                )
                                            })
                                        }
                                    </ul>
                                </li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive" to="/revathon">REV-A-THON</NavLink></li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive" to="/about-us">About
                                    Us</NavLink></li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive"
                                             to="/partner">Partners</NavLink></li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive"
                                             to="/news&blogs">News & Blogs</NavLink></li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive"
                                             to="/career">Career</NavLink></li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive" to="/contact">Contact
                                    Us</NavLink></li>
                                <NavLink to="/get-started"><img src={imagesPath.img26} className="getstartbtn" alt=""/></NavLink>
                            </ul>
                        </nav>
                    </div>
                </header>
            </div>
            <div className="d-md-none">
                <header id="header" className={classNames(
                    "non-shrink d-flex align-items-center",
                    {"shrink d-flex align-items-center": isShrunk}
                )}>
                    <div className="container " style={{
                        display: 'flex',
                        justifyContent: ' space-between',
                        alignItems: 'center',
                    }}>
                        <div className="logo">
                            <NavLink to="/"><img src={require("../images/logo.png")} alt="logo"/></NavLink>
                        </div>
                        <div className="humbargermenu" onClick={showmenuClk}>
                            <img src={require('../images/humbarger_menu.png')} alt="" className="hum"/>
                            <img src={require('../images/humbarger_menu_white.png')} alt="" className="humwhite"/>
                        </div>
                        <div className={`menuOverlay ${showmenu ? 'showmenuoverlay' : ''}`}
                             onClick={showmenuClk}>
                        </div>
                        <nav id="navbar" className={`${showmenu ? 'showmenu' : 'navbar'}`}>
                            <div className="closemenu" onClick={showmenuClk}><i className="fas fa-times"/></div>
                            <ul>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive"
                                             to="/">Home</NavLink></li>
                                <li className="dropdown"><NavLink exact activeclass="navactive"
                                                                  to="/product"><span>Products</span> <i
                                    className="bi bi-chevron-down"></i></NavLink>
                                    <ul>
                                        {
                                            menuItems.map((ele, index) => {
                                                return (
                                                    <li key={index}><Link to={ele.path} onClick={() => {
                                                        goToViolation(ele.id)
                                                        showmenuClk()
                                                    }}>{ele.title}</Link></li>
                                                )
                                            })
                                        }
                                    </ul>
                                </li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive" to="/revathon">REV-A-THON</NavLink></li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive" to="/about-us">About
                                    Us</NavLink></li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive"
                                             to="/partner">Partners</NavLink></li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive"
                                             to="/news&blogs">News & Blogs</NavLink></li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive"
                                             to="/career">Career</NavLink></li>
                                <li><NavLink className="nav-link scrollto" exact activeclass="navactive" to="/contact">Contact
                                    Us</NavLink></li>
                                <NavLink to="/get-started"><img src={imagesPath.img26} className="getstartbtn" alt=""/></NavLink>
                            </ul>
                        </nav>
                    </div>
                </header>
            </div>
        </div>
    )
}

export default Headers



// WEBPACK FOOTER //
// ./src/components/Headers.js